<script setup lang="ts">
import { useDisciplineStageLogsStore } from '../model/stage-logs/store'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import DisciplineStageLogs from './DisciplineStageLogs.vue'

defineOptions({
  name: 'DisciplineStageLogsPage',
})

const store = useDisciplineStageLogsStore()

/** The first page of logs shares the page loader with the discipline; a further page shows its own loader under
 *  the feed. */
const refIsFirstLoad = computed<boolean>(() => store.isLoading && !store.getLogs.length)

onBeforeUnmount(() => {
  store.reset()
})
</script>

<template>
  <DisciplinePageLoader :loading="refIsFirstLoad" />
  <DisciplineStageLogs />
</template>
